import { apiRequest } from './api';
import { Logo, LogoRequest } from '../types/logo';

export const logoService = {
  // Get all logos
  getAllLogos: async (): Promise<Logo[]> => {
    return await apiRequest<Logo[]>('/logos');
  },

  // Get logo by ID
  getLogoById: async (id: number): Promise<Logo> => {
    return await apiRequest<Logo>(`/logos/${id}`);
  },

  // Get default logo
  getDefaultLogo: async (): Promise<Logo> => {
    return await apiRequest<Logo>('/logos/default');
  },

  // Create new logo
  createLogo: async (logo: LogoRequest): Promise<Logo> => {
    return await apiRequest<Logo>('/logos/create', {
      method: 'POST',
      body: JSON.stringify(logo)
    });
  },

  // Update existing logo
  updateLogo: async (id: number, logo: LogoRequest): Promise<Logo> => {
    return await apiRequest<Logo>(`/logos/${id}`, {
      method: 'PUT',
      body: JSON.stringify(logo)
    });
  },

  // Delete logo
  deleteLogo: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/logos/${id}`, {
      method: 'DELETE'
    });
  },

  // Upload logo file
  uploadLogoFile: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    
    // Get token from stored session (same as api.ts)
    const storedSession = localStorage.getItem('userSession');
    if (!storedSession) {
      throw new Error('No authentication session found');
    }
    
    const session = JSON.parse(storedSession);
    if (!session.token) {
      throw new Error('No authentication token found');
    }
    
    // Use direct backend URL in development to bypass proxy issues
    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '';
    
    const response = await fetch(`${baseUrl}/api/logos/upload`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.token}`,
      },
      body: formData
    });

    if (!response.ok) {
      // Handle authentication errors
      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('userSession');
        window.location.href = '/login';
        throw new Error('Authentication failed. Please log in again.');
      }
      
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to upload file');
    }

    const result = await response.json();
    return result.path;
  }
};
